<div data-test-fcom-filters-desktop class="ms-small-y" *ngIf="(isMobile$ | async) === false">
  <button
    class="filters-button flex flex--no-wrap rounded-medium ps-small-x font-body-1 white-bg border nordic-blue-400-border"
    fcomTooltip
    [options]="tooltipOptions"
    [content]="contentTooltip"
    [disabled]="disabled"
    [ngClass]="{ 'has-filtering': hasFiltering }"
    aria-controls="expandContainerId"
    [id]="expandButtonId"
    (click)="tooltipOpeningClick.emit()"
  >
    <span class="ps-small-y">{{ hasFiltering ? buttonTextWhenFiltered : buttonText }}</span>
    <span>{{ hasFiltering && numberToShowWhenFiltered ? '+' + numberToShowWhenFiltered : '' }}</span>
    <fcom-icon
      *ngIf="!disabled"
      name="chevron-down"
      class="rotate is-xxsmall ms-xxsmall-l flex flex--self-center"
    ></fcom-icon>
  </button>

  <ng-template #contentTooltip>
    <div [attr.aria-labelledby]="expandButtonId" id="expandContainerId" class="flex flex--space-between ps-medium">
      <h4 class="font-heading-5">{{ headerText }}</h4>
    </div>
    <ng-content select="[tooltip-content]"></ng-content>
    <div class="flex flex--row-reverse grey-50-bg ps-medium rounded-bottom-large">
      <fcom-button
        class="ms-small-l"
        [text]="primaryFooterButtonTitle"
        [theme]="ButtonTheme.PRIMARY_BLUE"
        (click)="primaryFooterButtonClick.emit()"
      ></fcom-button>
      <fcom-button
        [text]="secondaryFooterButtonTitle"
        [theme]="ButtonTheme.SECONDARY"
        (click)="secondaryFooterButtonClick.emit()"
      ></fcom-button>
    </div>
  </ng-template>
</div>

<div data-test-fcom-filters-mobile class="ms-small-y" *ngIf="isMobile$ | async">
  <button
    class="filters-button flex flex--no-wrap flex--center rounded-medium width--100 font-body-1 white-bg border nordic-blue-400-border"
    [disabled]="disabled"
    (click)="showModal.emit()"
  >
    <fcom-icon name="filter-options" class="is-xxsmall ms-xxsmall-l flex flex--self-center"></fcom-icon>
    <span class="ms-xxsmall-l ps-small-y flex">
      {{ buttonText }}
      <span
        *ngIf="hasFiltering"
        class="ms-xxsmall-l font-body-2 flex flex--self-center nordic-blue-900-bg white-text dot"
      >
        {{ numberToShowWhenFiltered }}
      </span>
    </span>
  </button>

  <fcom-modal
    [fullHeight]="false"
    [title]="modalTitle"
    [(open)]="isModalOpen"
    (close)="closeModal.emit()"
    [buttons]="ModalButtons.CUSTOM"
  >
    <ng-content select="[modal-content]"></ng-content>
    <fcom-notification
      data-test-mobile-notification
      *ngIf="dispayNotification"
      messageBox
      [theme]="NotificationTheme.WARNING"
      [iconName]="IconName.INFO"
      [iconCategory]="'svg-library'"
      [contentSpaceClass]="NotificationSpaceClass.PS_XSMALL"
    >
      <span> {{ notificationContent }}</span>
    </fcom-notification>
    <div buttons>
      <div class="flex flex--center flex--row-reverse grey-50-bg ps-medium rounded-bottom-large">
        <fcom-button
          class="ms-small-l"
          [text]="primaryFooterButtonTitle"
          [theme]="ButtonTheme.PRIMARY_BLUE"
          (click)="primaryFooterButtonClick.emit()"
        ></fcom-button>
        <fcom-button
          [text]="secondaryFooterButtonTitle"
          [theme]="ButtonTheme.SECONDARY"
          (click)="secondaryFooterButtonClick.emit()"
        ></fcom-button>
      </div>
    </div>
  </fcom-modal>
</div>
